define("checkout/components/checkout-button", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (or @hasActiveSubscription @hasActiveTrial)}}
    <Shared::Ui::Button
      @additional="block"
      @isDisabled={{not this.changePlanButtonEnabled}}
      @onClick={{perform @onChangePlan}}
      @size="large"
      @variant="none"
      class="tCH--btn--primary qa--update_plan"
      data-test-id="change-plan"
      ...attributes
    >
      {{#if this.isSeamlessCheckoutInProgress}}
        {{svg-jar "refresh" class="o--icon tCH--btn--primaryIcon"}}
      {{/if}}
      {{this.buttonText}}
  
    </Shared::Ui::Button>
  {{else}}
    <Shared::Ui::Button
      @additional="block"
      @isDisabled={{this.checkoutButtonDisabled}}
      @onClick={{perform @onCheckout}}
      @size="large"
      @variant="none"
      class="tCH--btn--primary qa--update_plan"
      data-test-id="purchase"
      ...attributes
    >
      {{#if this.isSeamlessCheckoutInProgress}}
        {{svg-jar "refresh" class="o--icon tCH--btn--primaryIcon"}}
      {{/if}}
      {{this.buttonText}}
    </Shared::Ui::Button>
  {{/if}}
  */
  {
    "id": "apawRgtQ",
    "block": "[[[41,[28,[37,1],[[30,1],[30,2]],null],[[[1,\"  \"],[8,[39,2],[[24,0,\"tCH--btn--primary qa--update_plan\"],[24,\"data-test-id\",\"change-plan\"],[17,3]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[28,[37,3],[[30,0,[\"changePlanButtonEnabled\"]]],null],[28,[37,4],[[30,4]],null],\"large\",\"none\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isSeamlessCheckoutInProgress\"]],[[[1,\"      \"],[1,[28,[35,5],[\"refresh\"],[[\"class\"],[\"o--icon tCH--btn--primaryIcon\"]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[1,[30,0,[\"buttonText\"]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,2],[[24,0,\"tCH--btn--primary qa--update_plan\"],[24,\"data-test-id\",\"purchase\"],[17,3]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[30,0,[\"checkoutButtonDisabled\"]],[28,[37,4],[[30,5]],null],\"large\",\"none\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isSeamlessCheckoutInProgress\"]],[[[1,\"      \"],[1,[28,[35,5],[\"refresh\"],[[\"class\"],[\"o--icon tCH--btn--primaryIcon\"]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[1,[30,0,[\"buttonText\"]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]]]],[\"@hasActiveSubscription\",\"@hasActiveTrial\",\"&attrs\",\"@onChangePlan\",\"@onCheckout\"],false,[\"if\",\"or\",\"shared/ui/button\",\"not\",\"perform\",\"svg-jar\"]]",
    "moduleName": "checkout/components/checkout-button.hbs",
    "isStrictMode": false
  });
  let CheckoutButtonComponent = _exports.default = (_class = class CheckoutButtonComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      // Setting here to avoid reactive updates after checkout is processed but before seamless checkout modal closes
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor2, this);
      _defineProperty(this, "isTrialCheckout", void 0);
      _defineProperty(this, "hasSubscriptionBeforeCheckout", void 0);
      this.isTrialCheckout = this.args.hasActiveTrial || this.args.isEligibleForTrial;
      this.hasSubscriptionBeforeCheckout = this.args.hasActiveSubscription || this.args.hasActiveTrial;
    }
    get buttonText() {
      if (this.isSeamlessCheckoutInProgress) {
        return this.isTrialCheckout ? this.intl.t('plans.checkout.plan.button_in_progress_trial') : this.intl.t('plans.checkout.plan.button_in_progress');
      }
      if (this.hasSubscriptionBeforeCheckout) {
        return this.isTrialCheckout ? this.intl.t('plans.checkout.plan.button_change_plan_trial') : this.intl.t('plans.checkout.plan.button_change_plan');
      }
      return this.isTrialCheckout ? this.intl.t('plans.checkout.plan.button_checkout_trial') : this.intl.t('plans.checkout.plan.button_checkout');
    }
    get isSeamlessCheckoutInProgress() {
      return this.seamlessCheckoutManager.isCheckoutInProgress;
    }
    get hasCheckoutChanges() {
      return !this.args.isSamePlan || !this.args.isSameInterval || this.args.hasAddonChange;
    }
    get checkoutButtonDisabled() {
      return !this.args.isPaymentMethodComplete || !this.args.hasCompleteAddress || !this.hasCheckoutChanges || this.args.onCheckout.isRunning || this.args.onCheckout.last?.isSuccessful;
    }
    get changePlanButtonEnabled() {
      if (!this.args.isPaymentMethodComplete || this.args.onChangePlan.isRunning || this.args.onChangePlan.last?.isSuccessful || !this.args.hasCompleteAddress || this.isOnAutoTrialWithoutNewOrSavedCreditCard) {
        return false;
      }
      return this.hasCheckoutChanges || this.canReactivate;
    }
    get isOnAutoTrialWithoutNewOrSavedCreditCard() {
      return this.args.isOnCardlessTrial && (!this.args.isPaymentMethodComplete || !this.args.hasCompleteAddress) && !this.args.savedStripeCard;
    }
    get canReactivate() {
      return this.args.hasActiveCancelledSubscription;
    }

    // Note: show if @showMissingInfoMessage true or not passed in at all.
    get shouldShowMissingInfo() {
      const argIsTrueOrEmpty = this.args.showMissingInfoMesage ?? true;
      return argIsTrueOrEmpty && (this.args.isPaymentMethodComplete || !this.args.hasCompleteAddress);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CheckoutButtonComponent);
});